import React from 'react';
import { Container, Nav, Card } from 'react-bootstrap';
import { Outlet, NavLink } from 'react-router-dom';
import { FaBuilding, FaTools, FaGraduationCap, FaUserTie } from 'react-icons/fa';

const CatalogosLayout = () => {
    return (
        <Container fluid className="py-4">
            <Card className="shadow-sm mb-4">
                <Card.Header className="bg-primary text-white">
                    <h4 className="mb-0">Gestión de Catálogos</h4>
                </Card.Header>
                <Card.Body>
                    <Nav variant="tabs" className="mb-4">
                        <Nav.Item>
                            <Nav.Link as={NavLink} to="/catalogos/areas" className="d-flex align-items-center">
                                <FaBuilding className="me-2" /> Áreas
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={NavLink} to="/catalogos/habilidades" className="d-flex align-items-center">
                                <FaTools className="me-2" /> Habilidades
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={NavLink} to="/catalogos/profesiones" className="d-flex align-items-center">
                                <FaGraduationCap className="me-2" /> Profesiones
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={NavLink} to="/catalogos/perfiles" className="d-flex align-items-center">
                                <FaUserTie className="me-2" /> Perfiles
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    
                    <Outlet /> {/* Aquí se renderizará el contenido de cada catálogo */}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default CatalogosLayout;